/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Oauth_Logged_In_AsInputs */



/**
* | output |
* | --- |
* | "Logged in as {name}" |
*
* @param {Oauth_Logged_In_AsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_logged_in_as = /** @type {((inputs: Oauth_Logged_In_AsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_Logged_In_AsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Connecté en tant que ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Conectado como ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Conectado como ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Connesso come ${i?.name}`)
	return /** @type {LocalizedString} */ (`Logged in as ${i?.name}`)
});